"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromBlendMode = {};
exports.toBlendMode = {
  'pass': 'pass through',
  'norm': 'normal',
  'diss': 'dissolve',
  'dark': 'darken',
  'mul ': 'multiply',
  'idiv': 'color burn',
  'lbrn': 'linear burn',
  'dkCl': 'darker color',
  'lite': 'lighten',
  'scrn': 'screen',
  'div ': 'color dodge',
  'lddg': 'linear dodge',
  'lgCl': 'lighter color',
  'over': 'overlay',
  'sLit': 'soft light',
  'hLit': 'hard light',
  'vLit': 'vivid light',
  'lLit': 'linear light',
  'pLit': 'pin light',
  'hMix': 'hard mix',
  'diff': 'difference',
  'smud': 'exclusion',
  'fsub': 'subtract',
  'fdiv': 'divide',
  'hue ': 'hue',
  'sat ': 'saturation',
  'colr': 'color',
  'lum ': 'luminosity'
};
Object.keys(exports.toBlendMode).forEach(function (key) {
  return exports.fromBlendMode[exports.toBlendMode[key]] = key;
}); // export const enum ColorSpace {
// 	RGB = 0,
// 	HSB = 1,
// 	CMYK = 2,
// 	Lab = 7,
// 	Grayscale = 8,
// }

var ColorMode;

(function (ColorMode) {
  ColorMode[ColorMode["Bitmap"] = 0] = "Bitmap";
  ColorMode[ColorMode["Grayscale"] = 1] = "Grayscale";
  ColorMode[ColorMode["Indexed"] = 2] = "Indexed";
  ColorMode[ColorMode["RGB"] = 3] = "RGB";
  ColorMode[ColorMode["CMYK"] = 4] = "CMYK";
  ColorMode[ColorMode["Multichannel"] = 7] = "Multichannel";
  ColorMode[ColorMode["Duotone"] = 8] = "Duotone";
  ColorMode[ColorMode["Lab"] = 9] = "Lab";
})(ColorMode = exports.ColorMode || (exports.ColorMode = {}));

var ChannelID;

(function (ChannelID) {
  ChannelID[ChannelID["Red"] = 0] = "Red";
  ChannelID[ChannelID["Green"] = 1] = "Green";
  ChannelID[ChannelID["Blue"] = 2] = "Blue";
  ChannelID[ChannelID["Transparency"] = -1] = "Transparency";
  ChannelID[ChannelID["UserMask"] = -2] = "UserMask";
  ChannelID[ChannelID["RealUserMask"] = -3] = "RealUserMask";
})(ChannelID = exports.ChannelID || (exports.ChannelID = {}));

var Compression;

(function (Compression) {
  Compression[Compression["RawData"] = 0] = "RawData";
  Compression[Compression["RleCompressed"] = 1] = "RleCompressed";
  Compression[Compression["ZipWithoutPrediction"] = 2] = "ZipWithoutPrediction";
  Compression[Compression["ZipWithPrediction"] = 3] = "ZipWithPrediction";
})(Compression = exports.Compression || (exports.Compression = {}));

var SectionDividerType;

(function (SectionDividerType) {
  SectionDividerType[SectionDividerType["Other"] = 0] = "Other";
  SectionDividerType[SectionDividerType["OpenFolder"] = 1] = "OpenFolder";
  SectionDividerType[SectionDividerType["ClosedFolder"] = 2] = "ClosedFolder";
  SectionDividerType[SectionDividerType["BoundingSectionDivider"] = 3] = "BoundingSectionDivider";
})(SectionDividerType = exports.SectionDividerType || (exports.SectionDividerType = {}));

var LayerMaskFlags;

(function (LayerMaskFlags) {
  LayerMaskFlags[LayerMaskFlags["PositionRelativeToLayer"] = 1] = "PositionRelativeToLayer";
  LayerMaskFlags[LayerMaskFlags["LayerMaskDisabled"] = 2] = "LayerMaskDisabled";
  LayerMaskFlags[LayerMaskFlags["InvertLayerMaskWhenBlending"] = 4] = "InvertLayerMaskWhenBlending";
  LayerMaskFlags[LayerMaskFlags["LayerMaskFromRenderingOtherData"] = 8] = "LayerMaskFromRenderingOtherData";
  LayerMaskFlags[LayerMaskFlags["MaskHasParametersAppliedToIt"] = 16] = "MaskHasParametersAppliedToIt";
})(LayerMaskFlags = exports.LayerMaskFlags || (exports.LayerMaskFlags = {}));

var MaskParameters;

(function (MaskParameters) {
  MaskParameters[MaskParameters["UserMaskDensity"] = 1] = "UserMaskDensity";
  MaskParameters[MaskParameters["UserMaskFeather"] = 2] = "UserMaskFeather";
  MaskParameters[MaskParameters["VectorMaskDensity"] = 4] = "VectorMaskDensity";
  MaskParameters[MaskParameters["VectorMaskFeather"] = 8] = "VectorMaskFeather";
})(MaskParameters = exports.MaskParameters || (exports.MaskParameters = {}));